module.exports = __webpack_public_path__ + "static/media/ops_interview_en.0f62d050.png";